import Bugsnag from '@bugsnag/js'

export const setLogUser = (id: string): void => {
  Bugsnag.setUser(id)
}
